/* eslint-disable */
import { setPoiGallery } from "~/state/gallery/state";
import { store } from "~/state/store";
import { lookupbox } from "~/util/providers/poiagg";
import { getMarkerImgFrompoi, sceneCoordsToPoints } from "~/util/wasm";
import { WASM_ZINDEX } from "~/wasm/const";
import WasmCustomMapGeometry from "~/wasm/custom-items/wasm-custom-map-geometry";
import WasmCustomMapMarker from "~/wasm/custom-items/wasm-custom-map-marker";
import WasmCustomMap from "~/wasm/custom-map";
import ControlLayer from "./control-layer";
import ControlZoom from "./control-zoom";
import ControlBestfit from "./control-bestfit";

const CANVAS_CLASS_NAME = "wasm-photo-markers";

interface IOpts {
	showControls?: boolean;
	onMarkerClick?: (source: string, id: number) => void;
}

interface IDetailPoi {
	coords: Array<number>;
	geom: {
		data: Array<string>;
		type: string;
	};
	typeId: number;
	typeName: string;
}

const ZOOM_RANGE = [3, 19];

export default class WasmMap {
	#opts: IOpts;

	#node: HTMLDivElement;

	#canvas: HTMLCanvasElement;

	#customMap: WasmCustomMap;

	#detailMarker: WasmCustomMapMarker;

	#detailGeometry: WasmCustomMapGeometry;

	#markers: Array<WasmCustomMapMarker>;

	#markersObj: {[key: string]: WasmCustomMapMarker};

	#hoverMarker: WasmCustomMapMarker;

	#hoverAddMarker: WasmCustomMapMarker;

	#geometries: Array<WasmCustomMapGeometry>;

	#detailMarkerData: IDetailPoi;

	#userPublicId: string;

	#poi: { source: string; id: number; };

	#myGallery: boolean;

	#request: null | { abort: () => void; };

	#coordsToZoomData: {
		coords: null | Array<any>;
		animate: boolean;
	};

	#padding: {
		top: number;
		left: number;
		right: number;
		bottom: number;
	};

	#controlLayer: ControlLayer;

	#controlZoom: ControlZoom;

	#controlBestFit: ControlBestfit;

	constructor(opts: IOpts) {
		this.#opts = {
			onMarkerClick: () => {},
			showControls: false,
			...opts,
		};

		const cover = document.createElement("div");
		const canvas = document.createElement("canvas");

		cover.classList.add("wasm-photo-markers-cover");
		cover.classList.add("gallery-map");
		canvas.classList.add(CANVAS_CLASS_NAME);
		cover.append(canvas);

		const mapState = store.getState().map;

		this.#node = cover;
		this.#canvas = canvas;
		this.#markers = [];
		this.#markersObj = {};
		this.#hoverMarker = null;
		this.#hoverAddMarker = null;
		this.#geometries = [];
		this.#detailMarker = null;
		this.#detailGeometry = null;
		this.#detailMarkerData = null;
		this.#userPublicId = "";
		this.#customMap = new WasmCustomMap({
			canvas: this.#canvas,
			canvasClassName: CANVAS_CLASS_NAME,
			mapStyle: {
				base: "zakladni",
				variant: "desaturate",
			},
			position: {
				lon: mapState.longitude,
				lat: mapState.latitude,
				zoom: mapState.zoom,
			},
			onLoad: () => {
				if (this.#coordsToZoomData) {
					this.#zoomToCoords();
				}
			},
			onRedraw: () => {
				const curZoom = this.#customMap.getZoom();

				if (curZoom === ZOOM_RANGE[1]) {
					this.#controlZoom.zoomIn = true;
				} else {
					this.#controlZoom.zoomIn = false;
				}

				this.#mapRedraw();
			},
		});
		this.#poi = null;
		this.#myGallery = false;
		this.#request = null;
		this.#coordsToZoomData = {
			coords: null,
			animate: false,
		};
		this.#padding = {
			top: 46,
			bottom: 32,
			left: 28,
			right: 28,
			...!this.#opts.showControls
				? {
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}
				: {},
		};
		this.#controlLayer = new ControlLayer({
			onChange: layer => {
				switch (layer) {
					case "none":
						this.#customMap.setMapstyle({
							base: "zakladni",
							variant: "desaturate",
						});
						break;

					case "ophoto":
						this.#customMap.setMapstyle({
							base: "letecka",
						});
						break;

					case "turist":
						this.#customMap.setMapstyle({
							base: "turisticka",
						});
						break;

					default:
				}
			},
		});
		this.#controlZoom = new ControlZoom({
			onZoom: direction => {
				const curCenterZoom = this.#customMap.getCenterZoom();
				const newZoom = curCenterZoom.zoom + direction;

				this.#customMap.setCenterZoomAnim(curCenterZoom.lon, curCenterZoom.lat, newZoom);
			},
		});
		this.#controlBestFit = new ControlBestfit({
			onBestFit: () => {
				this.#controlBestFit.show = false;

				const customEvent = new CustomEvent("best-fit");

				this.#node.dispatchEvent(customEvent);
			},
		});
		this.#controlBestFit.show = false;
		this.#node.append(this.#controlLayer.getContainer(), this.#controlZoom.getContainer(),  this.#controlBestFit.getContainer());
	}

	destroy() {
		for (const wasmMarker of this.#markers) {
			wasmMarker.destroy();
		}

		for (const wasmGeometry of this.#geometries) {
			wasmGeometry.destroy();
		}

		this.#detailMarker?.destroy();
		this.#detailGeometry?.destroy();

		this.#customMap.destroy();
		this.#node.remove();
		this.#canvas.remove();
		this.#controlLayer.destroy();
	}

	load() {
		setTimeout(async () => {
			this.#customMap.load();
		}, 100);
	}

	get node() {
		return this.#node;
	}

	get centerZoom() {
		return null;
	}

	set centerZoom({ coords, zoom }) {
		this.#customMap.setCenterZoomAnim(coords[0], coords[1], zoom);
	}

	get activeLayer() {
		return null;
	}

	set userPublicId(userPublicId: string) {
		this.#userPublicId = userPublicId;
		this.#mapRedraw();
	}

	set my(value: boolean) {
		this.#myGallery = value;
	}

	set detailMarker(data: IDetailPoi) {
		this.#detailMarkerData = data;
		this.#createDetailMarker();
	}

	set POI({ source, id }) {
		this.#poi = {
			source,
			id,
		};
		this.#mapRedraw();
	}

	sync() {
		setTimeout(() => {
			this.#customMap.syncPort();
		}, 250);
	}

	hoverMarker(source?: string, id?: number, data?: any) {
		if (this.#hoverMarker) {
			this.#hoverMarker.update({
				visual: "inactive",
				bringToTheFront: false,
			});
			this.#hoverMarker = null;
		}

		if (this.#hoverAddMarker) {
			this.#hoverAddMarker.destroy();
			this.#hoverAddMarker = null;
		}

		if (source) {
			const markerId = `${source}_${id}`;

			if (markerId in this.#markersObj) {
				this.#hoverMarker = this.#markersObj[markerId];
				this.#hoverMarker.update({
					visual: "standard",
					bringToTheFront: true,
				});
			} else if (data) {
				const urlItem = data.urls.filter(item => item.urlType === "placeholder")[0];

				this.#hoverAddMarker = this.#customMap.createMarker({
					type: "photo",
					lon: data.mark.lon,
					lat: data.mark.lat,
					img: urlItem
						? urlItem.url.replace("{width}", 80).replace("{height}", 80)
						: "",
					visual: "standard",
					bringToTheFront: true,
					zIndex: WASM_ZINDEX.marker.photo,
				});
			}
		}
	}

	addMarkers(items: Array<any>) {
		const curIds = Object.keys(this.#markersObj);
		const newMarkers: Array<WasmCustomMapMarker> = [];

		for (const item of items) {
			const id = `${item.source}_${item.id}`;

			if (id in this.#markersObj) {
				const ind = curIds.indexOf(id);

				if (ind !== -1) {
					curIds.splice(ind, 1);
				}

				newMarkers.push(this.#markersObj[id]);

				continue;
			}

			const marker = this.#customMap.createMarker({
				type: "photo",
				lon: item.mark.lon,
				lat: item.mark.lat,
				img: item.url.replace("{width}", 80).replace("{height}", 80),
				visual: "inactive",
				zIndex: WASM_ZINDEX.marker.photo,
				interactionType: "click-hover",
			}, {
				onClick: () => {
					this.hoverMarker();
					this.#opts.onMarkerClick(item.source, item.id);
				},
				onEnter: () => {
					marker.update({
						visual: "standard",
					});
				},
				onLeave: () => {
					marker.update({
						visual: "inactive",
					});
				},
			});

			newMarkers.push(marker);
			this.#markersObj[id] = marker;
		}

		for (const oldId of curIds) {
			this.#markersObj[oldId].destroy();
			delete this.#markersObj[oldId];
		}

		this.#markers = newMarkers;
	}

	showBestFitControl() {
		this.#controlBestFit.show = true;
	}

	controlKeyboard() {}

	setCenterZoomFromCoords(coords: Array<any>, animate?: boolean) {
		if (coords.length === 0) {
			return null;
		}

		this.#coordsToZoomData = {
			coords,
			animate,
		};

		if (this.#customMap.loaded) {
			this.#zoomToCoords();
		}

		return null;
	}

	#createDetailMarker() {
		if (!this.#detailMarkerData) {
			return;
		}

		this.#detailMarker?.destroy();
		this.#detailGeometry?.destroy();

		if (this.#detailMarkerData.geom) {
			this.#detailGeometry = this.#customMap.createGeometry({
				type: "poi-geom",
				strPoints: this.#detailMarkerData.geom.data,
				zIndex: WASM_ZINDEX.geometry.poiDetail,
			});
		} else {
			this.#detailMarker = this.#customMap.createMarker({
				type: "big",
				lon: this.#detailMarkerData.coords[0],
				lat: this.#detailMarkerData.coords[1],
				visible: true,
				zIndex: WASM_ZINDEX.marker.poiDetailPhotos,
				customData: {
					// @ts-ignore
					url: getMarkerImgFrompoi(this.#detailMarkerData),
				},
				interactionType: "hover",
			});
		}
	}

	#mapRedraw() {
		if (!this.#customMap.loaded) {
			return;
		}

		const viewport = this.#customMap.getViewport();
		const zoom = this.#customMap.getZoom();

		if (this.#poi?.source === "firm") {
			return;
		}

		const opts: any = {
			zoom,
			// tady je to asi jedno
			mapsetId: 26,
			sources: ["foto"],
		};

		if (this.#userPublicId !== "") {
			opts.userPublicId = this.#userPublicId;
		} else if (this.#poi) {
			opts.poiSource = this.#poi.source;
			opts.poiId = this.#poi.id;
		}

		if (!this.#myGallery) {
			opts.approval = true;
		}

		// pouze lookupbox pro fotky, ne poie!
		if (this.#request) {
			this.#request.abort();
			this.#request = null;
		}

		const lookupboxData = lookupbox(viewport.lb.lon, viewport.lb.lat, viewport.rt.lon, viewport.rt.lat, opts);

		this.#request = lookupboxData.request;
		lookupboxData.promise.then(data => {
			store.dispatch(setPoiGallery({
				// @ts-ignore
				poiGallery: data.poi,
				poiGalleryInd: 0,
			}));
		}, () => {});
	}

	#zoomToCoords() {
		const { coords, animate } = this.#coordsToZoomData;

		if (!Array.isArray(coords)) {
			/* eslint-disable-next-line */
			console.error(["Wrong zoom to coords", coords]);
			return;
		}

		this.#customMap.zoomToCoords({
			coords,
			padding: this.#padding,
			animate,
		})
	}
}
